module.exports = __webpack_public_path__ + "static/media/halvvarm.13df6661.mp3";